import swal from 'sweetalert2'

const promptIssueDetails = (defaultNote = '') => new Promise((resolve) => {
  swal.fire({
    title: 'Please describe what did not go as expected on your end.',
    input: 'textarea',
    inputPlaceholder: 'E.g. I arrived late for the appointment, agent was unhappy, delays on site, etc.',
    inputValue: defaultNote,
    inputAttributes: {
      style: 'min-height: 110px; max-height: 180px; font-size: 14px; line-height: 1.4; padding: 10px; margin: 0;',
    },
    showCancelButton: true,
    confirmButtonText: 'Submit',
    showClass: 'slide-from-top',
    allowOutsideClick: false,
    preConfirm: (value) => {
      const trimmed = value?.trim()
      if (!trimmed) {
        swal.showValidationMessage('Please describe the issue.')
        return false
      }

      return trimmed
    },
  }).then(({ isConfirmed, value }) => {
    if (isConfirmed && value) {
      resolve({ shouldContinue: true, isCritical: true, criticalNote: value })
    } else {
      resolve({ shouldContinue: false, isCritical: false, criticalNote: null })
    }
  })
})

const promptCriticalIssue = (defaultNote = '') => new Promise((resolve) => {
  swal.fire({
    title: 'Were there any issues with this job?',
    icon: 'question',
    showCancelButton: false,
    confirmButtonText: 'Yes',
    showDenyButton: true,
    denyButtonText: 'No',
    denyButtonColor: '#e2001a',
    showClass: 'slide-from-top',
    allowOutsideClick: false,
  }).then(({ isConfirmed }) => {
    if (isConfirmed) {
      promptIssueDetails(defaultNote).then(resolve)
    } else {
      resolve({ shouldContinue: true, isCritical: false, criticalNote: null })
    }
  })
})

export default promptCriticalIssue